import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../store/modules/subscription';

const useSubscriptionList = () => {
  const dispatch = useDispatch();
  const list = useSelector(subscriptionSelectors.selectSubscriptionList);
  const isPending = useSelector(
    subscriptionSelectors.selectSubscriptionListPending
  );

  const isAlreadyFetched = !!list || isPending;

  const fetchSubscriptionList = useCallback(() => {
    if (isAlreadyFetched) return;
    dispatch(subscriptionActions.fetchSubscriptionList());
  }, [isAlreadyFetched]);

  return { fetchSubscriptionList };
};

export default useSubscriptionList;
